function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { Spinner, useOverlayContext } from 'seagull';
import ContactPicker from "../../ContactsPicker/ContactPicker";
import { NewContactModel } from "../../../models";
import React, { useEffect } from 'react';
import { ManageContactModalForVendor } from "../../ManageContactModal";
import { useStore, useStoreActions } from "../../../store/store-context";
import { useOnMount } from "../../../hooks/useOnMount";
import { GlobalBillModalErrorMessages } from "../GlobalBillModal.types";
const ContactsSelector = _ref => {
  let {
    onChange: _onChange,
    error,
    selectedContactId
  } = _ref;
  const overlayContext = useOverlayContext();
  const {
    fetchContacts
  } = useStoreActions();
  const {
    data: contacts,
    loading,
    error: contactsError
  } = useStore(state => state.contacts);
  const selectedContact = contacts === null || contacts === void 0 ? void 0 : contacts.find(c => c.id() === selectedContactId);
  useOnMount(() => {
    fetchContacts();
  });
  useEffect(() => {
    if (contactsError !== null) {
      overlayContext.showErrorToast(GlobalBillModalErrorMessages.FailedToRequestContacts, 'contacts-error-request-toast');
    }
  }, [contactsError]);
  async function openContactModal(props) {
    return overlayContext.showModal({
      closeOnEscapeKey: false,
      closeOnClickOutside: false,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(ManageContactModalForVendor, _extends({}, props, {
          "data-testid": "manage-contact-modal",
          onClose: dismissModal,
          origin: "Global bill modal"
        }));
      }
    });
  }
  async function newContactPostActions(savedContact) {
    if (savedContact) {
      await fetchContacts();
      _onChange(savedContact.id());
    }
  }
  if (loading) {
    return /*#__PURE__*/React.createElement(Spinner, {
      centeredInBox: true,
      size: 40,
      centerBoxHeight: 48
    });
  }
  return /*#__PURE__*/React.createElement(ContactPicker, {
    label: "Contact to bill",
    hideSampleContact: true,
    value: selectedContact !== null && selectedContact !== void 0 ? selectedContact : NewContactModel.makeEmpty(),
    error: error,
    onChange: async change => {
      switch (change.type) {
        case 'existingContact':
          _onChange(change.id);
          break;
        case 'initial':
          _onChange(null);
          break;
        case 'newContact':
          {
            const savedContact = await openContactModal({});
            await newContactPostActions(savedContact);
            break;
          }
        default:
          break;
      }
    }
  });
};
export default ContactsSelector;